import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../css/DateInput.css';

const TimeInput = ({
  value,
  onChange,
  name,
  className = '',
  disabled = false,
  placeholder = 'Select time',
  ...props
}) => {
  // Convert HH:mm time string to Date object
  const getDateFromTime = (timeString) => {
    if (!timeString) return null;
    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    date.setSeconds(0);
    return date;
  };

  const timeValue = value ? getDateFromTime(value) : null;

  const handleChange = (time) => {
    if (time) {
      // Format the time as HH:mm to match the native input format
      const hours = String(time.getHours()).padStart(2, '0');
      const minutes = String(time.getMinutes()).padStart(2, '0');
      const formattedTime = `${hours}:${minutes}`;

      // Create a synthetic event to match the native input onChange signature
      const syntheticEvent = {
        target: {
          name: name,
          value: formattedTime
        }
      };
      onChange(syntheticEvent);
    }
  };

  return (
    <DatePicker
      selected={timeValue}
      onChange={handleChange}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeCaption="Time"
      dateFormat="HH:mm"
      timeFormat="HH:mm"
      className={`form-control small-font ${className}`}
      disabled={disabled}
      placeholderText={placeholder}
      autoComplete="off"
      {...props}
    />
  );
};

export default TimeInput;
